import {
  CardSelectionDropdownTexts,
  CommonTexts,
  DetailsPageTexts,
  FooterComponentTexts,
  HeaderComponentTexts,
  LoginModalTexts,
  OfferListingPageTexts,
  OrderHistoryTexts,
  PreLoginPageTexts,
} from '../environment.interface';

const commonTexts: CommonTexts = {
  back: 'Retour',
  orderHistory: 'Historique des commandes',
  loginButtonLabel: 'Se connecter',
  getStarted: 'Commencer',
  orderSummary: 'Résumé de la commande',
  copyCode: 'Copier le code',
  redeemNow: 'Utiliser maintenant',
  validTill: 'Valable jusqu’au',
  viewDetails: 'Voir les détails',
  orderId: 'ID de commande',
  welcome: 'Bienvenue',
  errorMsgs: {
    tryLater: 'Une erreur s’est produite, veuillez réessayer plus tard.',
    redirectingToOrderHistory:
      'Une erreur s’est produite, redirection vers l’historique des commandes',
    paymentFailed: 'Échec du paiement, réessayez plus tard.',
  },
};

const reverificationLogoutText: string =
  'Vous serez déconnecté dans {{ countdown }} secondes pour revérification';

const preLoginPage: PreLoginPageTexts = {
  header: {
    heading: `Découvrez des offres exclusives et des avantages premium, en partenariat avec Visa`,
    subHeading: 'Profitez de réductions et d’offres sur vos marques préférées',
    loginButtonLabel: 'cliquez ici pour vous connecter',
    loginSubText: 'Déjà inscrit ?',
  },
  programBenefits: {
    tabHeading: 'Avantages du programme',
    heading: 'Découvrez des possibilités illimitées avec votre carte Visa',
    offers: {
      title: 'Économisez avec Visa',
      description: `Accédez à une grande variété d'offres, y compris voyages, jeux, streaming, cadeaux et plus encore.`,
      subtext: `Trouvez vos préférés à l'intérieur.`,
      linkLabel: 'découvrir les offres',
    },
  },
  howToRedeem: {
    tabHeading: 'Comment échanger',
    heading: 'Comment débloquer vos avantages Visa?',
    steps: [
      {
        number: '1',
        title: 'S’inscrire',
        description:
          'Si vous êtes nouveau dans ce programme, veuillez entrer les détails de votre carte pour vous inscrire',
      },
      {
        number: '2',
        title: 'Vérifiez votre e-mail',
        description:
          'Entrez votre adresse e-mail enregistrée et vérifiez avec l’OTP',
      },
      {
        number: '3',
        title: 'Vérification 3DS',
        description:
          'Entrez les détails de votre carte pour vous authentifier et débloquer les récompenses',
      },
    ],
  },
};

const offerListingPage: OfferListingPageTexts = {
  heading: 'Profitez de réductions fantastiques avec votre carte Visa',
  categoryLabel: 'Catégories',
  allCategoryLabel: 'Tous',
  offersTabLabel: 'Profitez de réductions',
  dealsTabLabel: 'Offres Exclusives',
  offerCardsConfig: {
    primaryBtnLabel: `Profitez de l'offre`,
  },
};

const orderHistoryPage: OrderHistoryTexts = {
  categories: [
    { name: 'offres promotionnelles', type: 'offer' },
    { name: 'offres exclusives', type: 'exclusive' },
  ],
  noVoucherText: 'aucun bon requis',
  redeemFailedMessages: {
    title: `Une erreur s'est produite`,
    subtitle: 'Veuillez réessayer plus tard',
  },
  redirectionTexts: {
    hyperlinkText: 'Cliquez ici',
    normalText: 'pour savoir comment utiliser le code de l’offre.',
  },
  cardUsedText: 'Carte utilisée',
  couponHelperText: `Veuillez utiliser votre code promo lors du paiement dans l'application/le site marchand`,
  generatedOnText: 'Généré le',
  merchantOfferText: 'offre du commerçant',
  noOffersText: 'Aucune offre trouvée',
  statusMessages: {
    cancelled: 'Annulé',
    failed: 'Échoué',
    successful: 'Réussi',
    confirmed: 'Confirmé',
  },
  validityText: 'Validité',
  voucherCodeText: 'code du bon',
  cancelNow: 'Annuler maintenant',
  cabService: 'Service de taxi',
  from: 'de',
  to: 'à',
  car: 'Voiture',
  errorMsgs: { bookingCancelled: 'Réservation annulée avec succès' },
};

const footerComponent: FooterComponentTexts = {
  faqLabel: 'FAQ',
  poweredBy: 'Propulsé par',
  privacyPolicyLabel: 'Politique de confidentialité',
  termsAndConditionsLabel: 'Termes et Conditions',
};

const headerComponent: HeaderComponentTexts = {
  logoutButtonLabel: 'Se déconnecter',
  searchBarPlaceholder: 'Rechercher des marques ou des marchands',
  search: 'Recherche',
};

const loginModal: LoginModalTexts = {
  faqLine: {
    before: 'Veuillez consulter notre',
    link: 'FAQ',
    after: 'pour plus de détails',
  },
  landingSectionTitle:
    'Fournissez les détails de votre carte et vérifiez votre éligibilité',
  heading: 'Débloquez vos avantages',
  registerButtonLabel: `Débloquer mes offres`,
  returningUserLabel: 'Utilisateur existant?',
  cardNumberLabel: 'Entrez votre numéro de carte Visa',
  emailIdLabel: 'Entrez votre e-mail de connexion',
  emailIdErrorMsg: 'Veuillez entrer une adresse e-mail valide',
  consent1: { text: 'En vous connectant, vous acceptez nos' },
  consent2: {
    body: `En cochant cette case, vous acceptez que Visa collecte, utilise, traite et partage vos informations personnelles dans le cadre de la gestion de la campagne conformément à la Politique`,
    link: 'de confidentialité mondiale de Visa.',
  },
  pcidssText:
    'Les numéros de carte et de compte sont uniquement utilisés pour vérifier votre éligibilité et sont cryptés.',
  tryAgain: 'Réessayez',
  authPassMsg: 'Authentification réussie!',
  authFailMsg: 'Échec de l’authentification!',
  waitingForBank: 'En attente de votre banque...',
  unlockingVouchers: 'Déverrouillage de vos bons...',
  takeFewMinutes: 'Cela peut prendre quelques minutes',
  visaCard: 'Carte Visa',
  expiryDate: `Date d'expiration (MM/AA)`,
  redirectionText: {
    title: 'Vous serez redirigé vers le site de l’émetteur*',
    subtitle:
      '*Visa ne saurait être tenue responsable de toute erreur de communication entre vous et l’émetteur',
  },
  otpMessages: {
    resend: 'Renvoyer l’OTP',
    sent: 'OTP renvoyé avec succès',
    resendIn: 'Renvoyer le code OTP dans',
    enter: 'Entrez le code OTP envoyé à',
    request: 'Demander un code OTP',
    invalid: 'OTP invalide.',
    maxInvalid: 'Nombre maximal de tentatives OTP invalides atteint.',
    attemptsLeft: 'Il vous reste {{attempts}} tentative(s).',
    tooltip: `Veuillez vérifier votre dossier de courrier indésirable si vous n'avez pas reçu le code OTP dans votre boîte de réception`,
  },
  change: 'Modifier',
  submitBtnTitles: {
    proceed: 'Continuer',
    authCard: 'Authentifier la carte',
    submit: 'Soumettre',
    requesting: 'Demander',
  },
  cardVerification: 'Vérification de la carte',
  placeholders: { month: 'MM', year: 'AA' },
  errorMsgs: {
    invalidCard: 'Numéro de carte invalide',
    cardAlreadyMappedWithEmail:
      'La carte est déjà liée à un autre e-mail. Veuillez utiliser votre e-mail enregistré pour vous connecter',
    invalidUserCredentials:
      'Veuillez entrer un e-mail ou une carte valide/enregistré(e)',
    cardNotEligible:
      'Le numéro de carte saisi n’est pas éligible. Veuillez réessayer avec une carte éligible',
    verificationFailed:
      'Échec de la vérification. Veuillez réessayer plus tard',
    defaultErrorMsg1:
      'Veuillez entrer un e-mail valide/enregistré pour vous connecter',
    defaultErrorMsg2:
      'L’e-mail saisi n’est pas enregistré. Veuillez saisir votre e-mail enregistré pour vous connecter ou vous inscrire avec votre carte et votre e-mail.',
    tryAgain: 'Veuillez réessayer dans {{time}} minutes',
    expiry: {
      month: {
        invalid: `Le mois d'expiration n'est pas valide`,
        required: `Le mois d'expiration est requis`,
      },
      year: {
        required: `L'année d'expiration est requise`,
        invalid: `L'année d'expiration n'est pas valide`,
      },
    },
  },
};

const cardSelectionDropdown: CardSelectionDropdownTexts = {
  addNewCard: 'Ajouter une nouvelle carte',
  reVerify: 'Revérifier',
  unverified: 'Non vérifié',
};

const detailsPage: DetailsPageTexts = {
  about: 'À propos',
  orderDetails: 'Détails de la commande',
  amount: 'Montant',
  discount: 'Remise',
  totalPrice: 'Prix Total',
  payNow: 'Payer Maintenant',
  redeemed: 'Utilisé',
  buyNow: 'Acheter Maintenant',
  redeemNow: 'Utiliser Maintenant',
  readMore: 'Lire plus',
  readLess: 'Lire moins',
  errorMsgs: {
    failedBooking: 'Échec de la réservation',
  },
};

export const languageSpecificConfigs = {
  reverificationLogoutText,
  preLoginPage,
  offerListingPage,
  orderHistoryPage,
  footerComponent,
  headerComponent,
  commonTexts,
  loginModal,
  cardSelectionDropdown,
  detailsPage,
};
